import axios from 'axios';

import { getToken, logout } from '@/utils/auth';

const AXIOS_TIMEOUT_LIMIT = 30000;

export const apiBaseUrl =
  process.env.VITE_API_BASE_URL || 'http://localhost:5101/api';

export const rawApi = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: AXIOS_TIMEOUT_LIMIT,
});

let authInterceptorsRegistered = false;

/**
 * Register once. Reads `getToken()` on every request so login after page load
 * still sends `Authorization` (previously we bailed when token was missing at startup).
 */
export const setAuthInterceptors = () => {
  if (authInterceptorsRegistered) return;
  authInterceptorsRegistered = true;

  rawApi.interceptors.request.use((config) => {
    if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      delete config.headers.Authorization;
    }
    return config;
  });

  rawApi.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        const url = String(error.config?.url || '');
        const isAuthAttempt =
          url.includes('/auth/signin') || url.includes('/auth/signup');
        if (!isAuthAttempt) {
          logout();
        }
      }
      return Promise.reject(error);
    }
  );
};
